import axios from 'axios';

// Function to retrieve JWT token from sessionStorage
function getToken() {
  return sessionStorage.getItem('jwtToken');
}

const axiosInstance = axios.create({
  baseURL: `${window.location.origin}/api/v1`,  // Dynamic base URL, matching frontend/backend
  timeout: 5000,                                // Optional: 5 seconds timeout
});

// Request interceptor: Attach JWT token automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();  // Get the token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor: Handle 401 errors (token expired, invalid, etc.)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn('Unauthorized. Token might be expired or invalid.');
      // Redirect to login page, clear token, etc.
     // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
